import { render, staticRenderFns } from "./ReductionType.vue?vue&type=template&id=684069ef&"
import script from "./ReductionType.vue?vue&type=script&lang=js&"
export * from "./ReductionType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports